// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"printLabel__msignaturepad___1ONkY","m-signature-pad--body":"printLabel__m-signature-pad--body___5SRP6","m-signature-pad--footer":"printLabel__m-signature-pad--footer___17nRa","description":"printLabel__description___3GACc","button":"printLabel__button___j2CX7","clear":"printLabel__clear___2Cfh2","save":"printLabel__save___23RVO","m-signature-pad":"printLabel__m-signature-pad___1m_lZ","github":"printLabel__github___2kors","wrapper":"printLabel__wrapper___3STiU","wrapperParagraph":"printLabel__wrapperParagraph___2khqs","isLarge":"printLabel__isLarge___1Cgg2"};


//////////////////
// WEBPACK FOOTER
// ./client/app/screens/printLabel/printLabel.scss
// module id = FhFp
// module chunks = client